import React, {Component} from "react";
import {Input, Tooltip} from "antd";

const {Password} = Input;
export default class ComPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleCapsLock: false
        };
    }

    render() {
        const {
            id,
            placeholder,
            value,
            onChange=()=>{},
            InputRef,
            size,
            prefix,
            onKeyDown=()=>{},
            allowClear
        } = this.props;
        return (
            <Tooltip visible={this.state.visibleCapsLock} placement="topLeft" title="大写锁定已打开">
                <Password
                    id={id}
                    ref={InputRef}
                    size={size}
                    prefix={prefix}
                    allowClear={allowClear}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                        this.setState({
                            visibleCapsLock: false
                        });
                    }}
                    onFocus={(e)=>{
                        document.msCapsLockWarningOff = true;// 关闭ie默认的大写锁定提示
                    }}
                    onKeyDown={(e) => {
                        onKeyDown(e);
                        const ifCapsLock = e.getModifierState("CapsLock");
                        if(e.keyCode===20&&ifCapsLock){
                            if (document.msCapsLockWarningOff == false) { // 关闭ie默认的大写锁定提示
                                document.msCapsLockWarningOff = true;
                            }
                            this.setState({
                                visibleCapsLock: true
                            });
                            setTimeout(()=>{
                                this.setState({
                                    visibleCapsLock: false
                                });
                            },1000)
                        }
                    }}
                />
            </Tooltip>
        );
    }
}

